

















// vue
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class App extends Vue {
  @Prop({
    type: Object,
    required: true,
    default() {
      return {};
    },
  })
  public data!: any;
}
